import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCmP3780vOSTl_Z0ByAZu1Z1EWxDts8_9w",
    authDomain: "shabless-3cb69.firebaseapp.com",
    projectId: "shabless-3cb69",
    storageBucket: "shabless-3cb69.appspot.com",
    messagingSenderId: "895910073217",
    appId: "1:895910073217:web:a94977633ff53f2cd0ce80",
    measurementId: "G-EC8MBR0PX6"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);
